/**
 * Copyright 2022-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Dispatch } from "react";
import { Text } from "@nordcloud/gnui";
import { PatchingStatus } from "~/generated/graphql";
import { Mode } from "~/components";
import { FilterWrapper } from "~/components/SidebarWithMultiSelect/FilterWrapper";
import { SelectableListWithSearch } from "~/components/SidebarWithMultiSelect/SelectableListWithSearch";
import { Item } from "~/components/SidebarWithMultiSelect/types";
import { isNotEmpty, isNotNil } from "~/tools";
import { State } from "./types";

type Props = {
  state: State;
  updateState: Dispatch<Partial<State>>;
};

export function ResourceStatusFilters(props: Props) {
  const { state, updateState } = props;

  const clearLastPatchingStatusFilter = () => {
    updateState({
      lastPatchingStatuses: [],
      excludeLastPatchingStatuses: false,
    });
  };

  const lastPatchingStatusCheckboxes: Item[] = [
    {
      value: PatchingStatus.Success,
      label: "Successful",
    },
    {
      value: PatchingStatus.Failed,
      label: "Failed",
    },
    {
      value: PatchingStatus.Error,
      label: "Error",
    },
    {
      value: PatchingStatus.Timeout,
      label: "Timeout",
    },
    {
      value: PatchingStatus.NotInTimeWindow,
      label: "Not In Time Window",
    },
  ];

  return (
    <>
      <Text size="sm" weight="bold">
        Resource Status
      </Text>
      <FilterWrapper
        name="Last Patching Status"
        isSelected={
          isNotNil(state.lastPatchingStatuses) &&
          isNotEmpty(state.lastPatchingStatuses)
        }
        selectedOptions={state.lastPatchingStatuses ?? []}
        onClear={clearLastPatchingStatusFilter}
      >
        <SelectableListWithSearch
          allowModeChange
          selectedOptions={state.lastPatchingStatuses ?? []}
          selectableItems={lastPatchingStatusCheckboxes}
          isExcludeSelected={state.excludeLastPatchingStatuses}
          onMultiSelect={(selections) => {
            updateState({
              lastPatchingStatuses: selections,
            });
          }}
          onModeChange={(mode) => {
            updateState({
              excludeLastPatchingStatuses: mode === Mode.EXCLUDES,
            });
          }}
        />
      </FilterWrapper>
    </>
  );
}
